import { useEffect, useState } from 'react';
/**
 * Keeps SSR-rendered controls non-interactive until React has committed on the client.
 * Visibility is not proof that an event handler is attached during hydration.
 */
const useClientInteractiveReady = () => {
    const [ready, setReady] = useState(false);
    useEffect(() => {
        setReady(true);
    }, []);
    return ready;
};
export default useClientInteractiveReady;
//# sourceMappingURL=useClientInteractiveReady.js.map